export const isSystemMenu = (menu) => {
  const { key } = menu;
  return key.endsWith('main') || key.endsWith('sideMenu');
};
